module.exports = __webpack_public_path__ + "media/images/about-share-195e5783f0a627ed8f4f12903061cda3.jpeg";